import { createSelector } from '@ngrx/store';
import { AppState } from './index';

// Root selectors
export const selectAppState = (state: AppState) => state;

// Feature selectors will be added here
// export const selectAuth = (state: AppState) => state.auth;
// export const selectNotifications = (state: AppState) => state.notifications;

// Composed selectors will be added here
